// extracted by mini-css-extract-plugin
export default {"wrapper":"countOption_wrapper__1vm5y","label":"countOption_label__EVg4S","count":"countOption_count__SNqR6"};